/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import React from 'react';
import styled from 'styled-components';

import { CurrentTrackPoint } from '../common/interfaces/types';
import { baseHurricaneWidgetSpotlightIconPath } from './constants';
import { getHurricaneIconPath } from './hurricaneUtils';

interface ActiveHurricaneWidgetIconProps {
    currentTrackPoint: CurrentTrackPoint;
}

export const ActiveHurricaneWidgetIcon = ({ currentTrackPoint }: ActiveHurricaneWidgetIconProps) => {

    const imageSrc = getHurricaneIconPath(currentTrackPoint, baseHurricaneWidgetSpotlightIconPath);

    return (
        <IconContainer>
            {imageSrc ? <HurricaneIconImg src={imageSrc} /> : null}
        </IconContainer>
    );
};

const IconContainer = styled.div`
    display: flex;
    flex-direction: row;
    width: 100%;
    height: 100%;

    justify-content: center;
    align-items: center;
`;

const HurricaneIconImg = styled.img`
    width: 24px;
    height: 24px;
`;

